export default class Table {
  public static DATE_FORMAT_STRING = 'DD.MM.YYYY';
  public static DATETIME_FORMAT_STRING = 'DD.MM.YYYY HH:mm';
  public static TIME_FORMAT_STRING = 'HH:mm:ss';
  public static DATE_MONTH_FORMAT_STRING = 'MM. YYYY';
}
